import React from 'react';

// Описываем типы для входящих пропсов
interface GoogleAiSearchButtonProps {
    catalog: string | undefined;
    title: string | undefined;
    subDescription: string | undefined;
}

export const AiSearchButton: React.FC<GoogleAiSearchButtonProps> = ({ catalog, title, subDescription }) => {
  const searchQuery = (catalog || '') + ' ' + (title || '') + ' ' + (subDescription || '')
  // Кнопка заблокирована, если строка пустая или состоит только из пробелов
  const isDisabled = !searchQuery || !searchQuery.trim();

  const handleAiSearch = (): void => {
    if (isDisabled) return;

    // Безопасно кодируем строку запроса
    const encodedQuery = encodeURIComponent(searchQuery.trim());
    
    // udm=50 принудительно включает режим ИИ-ответов в Google
    const googleAiUrl = `https://google.com/search?q=${encodedQuery}&udm=50`;

    // Безопасное открытие новой вкладки
    window.open(googleAiUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    // <button 
    //   onClick={handleAiSearch} 
    //   className="collector-ai-btn"
    //   type="button"
    //   disabled={isDisabled}
    //   title={isDisabled ? "Введите описание предмета для активации" : "Сгенерировать ИИ-справку в Google"}
    // >
    <div onClick={handleAiSearch} className="ai-button">
      <svg 
        width="18" 
        height="18" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://w3.org" 
        style={{ flexShrink: 0, opacity: isDisabled ? 0.4 : 1, transition: 'opacity 0.25s' }}
        >
        <path d="M12 2L14.85 9.15L22 12L14.85 14.85L12 22L9.15 14.85L2 12L9.15 9.15L12 2Z" fill="url(#ai-blue-purple-grad)"/>
        <defs>
          <linearGradient id="ai-blue-purple-grad" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#4285F4"/>
            <stop offset="50%" stopColor="#9B51E0"/>
            <stop offset="100%" stopColor="#E94235"/>
          </linearGradient>
        </defs>
      </svg>
      {/* Gemini */}
    </div>
    // </button>
  );
};
